function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 64,
    width: 64,
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#ed7d31",
      strokeOpacity: 1,
      opacity: 1,
      strokeWidth: 7.04503938,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    d: "M104 107H24c-1.7 0-3-1.3-3-3V84c0-1.7 1.3-3 3-3s3 1.3 3 3v17h74V84c0-1.7 1.3-3 3-3s3 1.3 3 3v20c0 1.7-1.3 3-3 3z",
    fill: "#ed7d31"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 4,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      stroke: "#444b54",
      strokeOpacity: 1
    },
    d: "M64 77c-1.7 0-3-1.3-3-3V24c0-1.7 1.3-3 3-3s3 1.3 3 3v50c0 1.7-1.3 3-3 3z",
    fill: "#444b54"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 4,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      stroke: "#444b54",
      strokeOpacity: 1
    },
    d: "M79 42c-.8 0-1.5-.3-2.1-.9L64 28.2 51.1 41.1c-1.2 1.2-3.1 1.2-4.2 0-1.2-1.2-1.2-3.1 0-4.2l15-15c1.2-1.2 3.1-1.2 4.2 0l15 15c1.2 1.2 1.2 3.1 0 4.2-.6.6-1.3.9-2.1.9z",
    fill: "#444b54"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.b564ed8779df02f06c29aeb86dfdbb04.svg";
export { ForwardRef as ReactComponent };